export default "__VITE_ASSET__WCG$gMh0__"